<!-- 新增 -->

<template>
  <div class="dashboard-container tab-margin">
    <!-- 搜索 S -->
    <div class="top-search tab-padding">
      <div class="search">
        <div class="content">
          <div class="flex-2">
            <el-form label-position="top" inline label-width="120px">
              <el-form-item label="媒体渠道" class="form-label">
                <el-select
                  filterable
                  style="width: 300px"
                  v-model="temp.source"
                  multiple
                  placeholder="媒体渠道:所有"
                >
                  <el-option
                    v-for="item in mediaOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="国家/地区" class="form-label">
                <el-select
                  filterable
                  style="width: 300px"
                  v-model="temp.country"
                  placeholder="国家/地区:所有"
                  multiple
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="分组维度"
                class="form-label"
                style="width: 50%"
              >
                <el-select
                  v-model="temp.groupby"
                  style="width: 300px"
                  placeholder="分组维度:所有"
                  multiple
                >
                  <el-option
                    v-for="item in optionsAgg"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="flex-1">
            <el-form label-position="top" inline label-width="120px">
              <el-form-item label="日期范围" class="form-label">
                <el-date-picker
                  v-model="timeWrap"
                  type="datetimerange"
                  align="right"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="search-wrap">
          <div class="search-line" v-show="!shouqi">
            <div
              class="flex align-ct mg-b-10"
              v-for="(item, index) in searchList"
              :key="index"
            >
              <el-select
                class="mg-r-10"
                style="width: 300px"
                v-model="item.type"
                placeholder="请选择"
                @change="changeFilterOption"
              >
                <el-option
                  v-for="item in filterOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>

              <el-input
                v-if="item.type === 1"
                v-model="temp.pkg"
                placeholder="请输入App名称"
                clearable
                style="width: 240px"
              />

              <el-select
                clearable
                v-if="item.type === 2"
                v-model="temp.os"
                style="width: 240px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-input
                v-if="item.type === 3"
                v-model="temp.os_ver"
                placeholder="请输入操作系统版本"
                clearable
                style="width: 240px"
              />

              <el-input
                v-if="item.type === 4"
                v-model="temp.app_ver"
                placeholder="请输入App版本"
                clearable
                style="width: 240px"
              />

              <!-- <el-input
                v-if="item.type === 5"
                v-model="temp.country"
                placeholder="请输入国家"
                clearable
                style="width: 240px"
              /> -->

              <el-input
                v-if="item.type === 6"
                v-model="temp.model"
                placeholder="请输入手机型号"
                clearable
                style="width: 240px"
              />

              <el-input
                v-if="item.type === 7"
                v-model="temp.vip"
                placeholder="请输入VIP"
                clearable
                style="width: 240px"
              />

              <!-- <el-select
                clearable
                v-if="item.type === 8"
                v-model="temp.d_type"
                style="width: 240px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in optionsType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> -->

              <el-select
                clearable
                v-if="item.type === 9"
                v-model="temp.p"
                style="width: 240px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in optionsP"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!-- <el-switch
                @change="changeIsShow(item, index)"
                v-model="item.isShow"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch> -->
              <i
                class="el-icon-delete mg-l-10 cursor"
                @click="delSearchLine(index)"
              ></i>
            </div>
          </div>
          <div class="flex-between">
            <div class="left">
              <el-button icon="el-icon-plus" @click="addSearchLine"
                >添加更多过滤项</el-button
              >
              <i
                v-if="!shouqi"
                class="el-icon-arrow-up mg-l-20 cursor"
                @click="showSearch(true)"
              ></i>
              <i
                v-else
                class="el-icon-arrow-down mg-l-20 cursor"
                @click="showSearch(false)"
              ></i>
            </div>
            <div class="right">
              <!-- <el-button
                type="primary"
                icon="el-icon-top"
                class="search-btn"
                @click="toSearch(1)"
                :loading="loading"
                >升序</el-button
              >
              -->
              <div style="display: inline-block">
                <div style="display: flex">
                  <div
                    v-for="(item, index) in sortList"
                    :key="index"
                    style="margin-right: 20px; cursor: pointer"
                  >
                    <template v-if="item.prop !== 'date'">
                      <span style="color: #606266; font-size: 14px">
                        {{ tableLabel(item.prop) }}
                      </span>
                      <i
                        class="el-icon-top"
                        :class="{ sortActive: item.asc }"
                        @click="sortLine(item, 1)"
                        style="
                          margin-right: 10px;
                          font-size: 18px;
                          color: #606266;
                        "
                      ></i>
                      <i
                        class="el-icon-bottom"
                        :class="{ sortDscActive: item.des }"
                        style="font-size: 18px; color: #606266"
                        @click="sortLine(item, 2)"
                      ></i>
                    </template>
                  </div>
                </div>
              </div>
              <el-button
                type="primary"
                icon="el-icon-download"
                class="search-btn"
                @click="exportTable"
                :loading="loading"
                >导出</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-search"
                class="search-btn"
                @click="search"
                :loading="loading"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索 E -->
    <!-- <div class="table-title">当前App：{{curAppName}}</div> -->

    <!-- <div class="tab-wrap">
      <div class="tab-left">
        {{ activeTab === 1 ? "数据列表" : "数据图表" }}
      </div>
      <div class="tab-right">
        <div
          class="tab-right-item"
          @click="changeTab(1)"
          :class="activeTab === 1 ? 'tab-active' : ''"
        >
          表格
        </div>
        <div
          class="tab-right-item"
          @click="changeTab(2)"
          :class="activeTab === 2 ? 'tab-active' : ''"
        >
          图表
        </div>
      </div>
    </div> -->

    <div class="tab-container" style="margin-top: 20px">
      <div class="tab-container-bottom">
        <!-- 折线图 S -->
        <div class="chart-container" v-if="activeTab === 2">
          <echart :Xdata="Xdata" :Sdata="Sdata" :Ldata="Ldata"></echart>
          <!-- <echart-out
            :Xdata="Xdata1"
            :Sdata="Sdata1"
            :Ldata="Ldata1"
          ></echart-out> -->
        </div>
        <!-- 折线图 E -->

        <!-- 表格 S -->
        <div class="table-container" v-if="activeTab === 1">
          <!-- <div class="table-tip">数据表</div> -->

          <el-table
            @sort-change="sortChange"
            class="table-xinzeng"
            v-loading="loading"
            :data="
              tableData.slice(
                (pagination.page - 1) * pagination.limit,
                pagination.page * pagination.limit
              )
            "
            empty-text="暂无数据"
            style="width: 100%; min-height: 500px"
            :row-style="{ background: '#FCFDFF' }"
            :header-cell-style="{ background: '#2d3a5b', color: '#ffffff' }"
          >
            <!-- :filters="filterList[item]"
              :filter-method="filterTag" 
              filter-placement="bottom-end"
              -->
            <el-table-column
              v-for="(item, index) in hList"
              :key="index"
              :label="tableLabel(copyHlist[index])"
              :prop="item"
              align="center"
            >
            </el-table-column>

            <!-- <el-table-column v-if="hList.length > 0" label="数量" prop="count" align="center"></el-table-column> -->
          </el-table>

          <pagination
            :total="pagination.total"
            :page.sync="pagination.page"
            :limit.sync="pagination.limit"
            @pagination="getList()"
          />
          <div style="width: 100px; height: 20px" />
        </div>
        <!-- 表格 E -->
      </div>
    </div>

    <back-to-top
      :custom-style="myBackToTopStyle"
      :visibility-height="300"
      :back-position="50"
      transition-name="fade"
    />

    <back-to-bottom
      :visibility-height="300"
      :back-position="50"
      transition-name="fade"
    ></back-to-bottom>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { newList } from "@/api/inout.js";
import { countryList, mediaList } from "@/api/app.js";
import Pagination from "@/components/Pagination";
import BackToTop from "@/components/BackToTop";
import BackToBottom from "@/components/BackToBottom";
import Echart from "./chart";
import Sortable from "sortablejs";

export default {
  name: "Dashboard",
  computed: {
    ...mapGetters(["name", "cur_app", "pickerOptions"]),
  },
  watch: {
    cur_app(newVal) {
      this.temp.pkg = newVal;
      this.search();
    },
  },
  components: {
    Pagination,
    Echart,
    BackToTop,
    BackToBottom,
  },
  filters: {
    priceFilter: function name(num) {
      const price = num / 10;
      return price.toString().indexOf(".") !== -1
        ? price.toLocaleString()
        : price.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
  },
  data() {
    return {
      sortList: [],
      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: "最近一周",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "最近一个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //     {
      //       text: "最近三个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      //         picker.$emit("pick", [start, end]);
      //       },
      //     },
      //   ],
      // },
      myBackToTopStyle: {
        right: "50px",
        bottom: "120px",
        width: "40px",
        height: "40px",
        "border-radius": "4px",
        "line-height": "45px", // 请保持与高度一致以垂直居中 Please keep consistent with height to center vertically
        background: "#37474F", // 按钮的背景颜色 The background color of the button
      },
      options: [
        {
          value: "android",
          label: "Android",
        },
        {
          value: "ios",
          label: "IOS",
        },
      ],
      optionsType: [
        {
          value: 1,
          label: "日活量",
        },
        {
          value: 2,
          label: "新增",
        },
      ],
      optionsP: [
        {
          value: 1,
          label: "天",
        },
        {
          value: 2,
          label: "小时",
        },
      ],
      mediaOptions: [
        {
          value: "media1",
          label: "媒体1",
        },
        {
          value: "media2",
          label: "媒体2",
        },
      ],
      countryOptions: [],
      optionsAgg: [
        {
          value: "campaign_name",
          label: "campaign",
        },
        {
          value: "ad_group_id",
          label: "ad_group",
        },
        {
          value: "creative_id",
          label: "creative",
        },
        {
          value: "source",
          label: "渠道",
        },
        // {
        //   value: "pkg",
        //   label: "包名",
        // },
        // {
        //   value: "os",
        //   label: "操作系统",
        // },
        {
          value: "os_ver",
          label: "操作系统版本",
        },
        {
          value: "app_ver",
          label: "App版本",
        },
        {
          value: "country",
          label: "国家",
        },
        {
          value: "model",
          label: "手机型号",
        },
        {
          value: "vip",
          label: "用户类型",
        },
      ],
      temp: {
        pkg: "",
        os: "",
        os_ver: "",
        app_ver: "",
        country: [],
        model: "",
        vip: "",
        d_type: 2,
        p: "",
        groupby: [],
        source: [],
        orderby: {},
      },
      curAppName: "",
      activeTab: 1,
      loading: false,
      timeWrap: [],
      pagination: {
        limit: 30,
        page: 1,
        total: 0,
      },
      tableData: [],
      hList: [],

      filterOptions: [
        {
          value: 1,
          label: "app名称",
          model: "pkg",
          disabled: false,
        },
        // {
        //   value: 2,
        //   label: "操作系统",
        //   model: "os",
        //   disabled: false,
        // },
        {
          value: 3,
          label: "操作系统版本",
          model: "os_ver",
          disabled: false,
        },
        {
          value: 4,
          label: "app版本",
          model: "app_ver",
          disabled: false,
        },
        {
          value: 6,
          label: "手机型号",
          model: "model",
          disabled: false,
        },
        {
          value: 7,
          label: "用户类型",
          model: "vip",
          disabled: false,
        },
        // {
        //   value: 8,
        //   label: "类型",
        //   model: "d_type",
        //   disabled: false,
        // },
        // {
        //   value: 9,
        //   label: "间隔",
        //   model: "p",
        //   disabled: false,
        // },
      ],
      filterList: [],
      searchList: [],
      shouqi: false,
      sortable: null,
      copyHlist: [],
    };
  },

  created() {
    const that = this;
    const start = new Date();
    const end = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    that.timeWrap[0] = that.formatData(start);
    that.timeWrap[1] = that.formatData(end);

    this.curAppName = this.$route.query.name;

    countryList().then((res) => {
      this.countryOptions = res;
    });
    mediaList().then((res) => {
      this.mediaOptions = res;
    });

    this.temp.pkg = localStorage.getItem("curPkg");
  },

  mounted() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.columnDrop();
  },

  methods: {
    exportTable() {
      import("@/vendor/Export2Excel").then((excel) => {
        let tHeader = [];
        this.hList.forEach((item) => {
          tHeader.push(this.tableLabel(item));
        });
        const filterVal = this.hList;
        const data = this.formatJson(filterVal, this.tableData);
        excel.export_json_to_excel({
          header: tHeader, //表头 必填
          data, //具体数据 必填
          filename: "新增-导出", //非必填
          autoWidth: true, //非必填
          bookType: "xlsx", //非必填
        });
      });
    },
    formatJson(filterVal, tableData) {
      return tableData.map((v) => {
        return filterVal.map((j) => {
          return v[j];
        });
      });
    },
    sortLine(val, type) {
      if (type === 1) {
        val.asc = !val.asc;
        val.des = false;
      } else {
        val.des = !val.des;
        val.asc = false;
      }
      this.sortList.forEach((item) => {
        if (item.asc) {
          this.temp.orderby[val.prop] = 1;
        }
        if (item.des) {
          this.temp.orderby[val.prop] = -1;
        }
        if (!item.asc && !item.des && item.prop === val.prop) {
          delete this.temp.orderby[val.prop];
        }
      });
      if (val.prop === "date") return;
      this.search();
      console.log(this.sortList);
      console.log(this.temp.orderby);
    },
    filterTag(value, row, column) {
      return row[column.property] === value;
    },
    sortChange(column) {
      if (column.order === "ascending") {
        // 升序
        if (column.prop !== "date") {
          this.temp.orderby[column.prop] = 1;
        }
      } else {
        // 降序
        if (column.prop !== "date") {
          this.temp.orderby[column.prop] = -1;
        }
      }
      if (column.prop !== "date") {
        this.search();
      }
    },
    sortByCount(obj1, obj2) {
      let num1 = +obj1.count;
      let num2 = +obj2.count;
      return num1 - num2;
    },
    isSort(value) {
      let _re = false;
      if (value === "count") {
        _re = true;
      }
      return _re;
    },
    // 列拖拽
    columnDrop() {
      const wrapperTr = document.querySelector(
        ".table-xinzeng .el-table__header-wrapper tr"
      );
      this.sortable = Sortable.create(wrapperTr, {
        animation: 180,
        delay: 0,
        onEnd: (evt) => {
          const oldItem = this.hList[evt.oldIndex];
          this.hList.splice(evt.oldIndex, 1);
          this.hList.splice(evt.newIndex, 0, oldItem);
        },
      });
    },

    changeFilterOption() {
      this.filterOptions.forEach((it) => {
        it.disabled = false;
      });
      this.searchList.forEach((item) => {
        this.filterOptions.forEach((p) => {
          if (item.type === p.value) {
            p.disabled = true;
          }
        });
      });
    },
    showSearch(val) {
      this.shouqi = val;
    },
    changeIsShow(val, index) {
      console.log(val, index);
    },
    delSearchLine(index) {
      let _t = this.searchList[index].type;
      let _item =
        this.filterOptions.filter((item) => {
          return item.value === _t;
        })[0] || null;
      // 不清除包名

      if (_t !== 1 && _item) {
        this.temp[_item.model] = "";
      }
      this.searchList.splice(index, 1);
      this.changeFilterOption();
    },
    addSearchLine() {
      this.searchList.push({
        type: "",
        isShow: false,
      });
      // this.changeFilterOption()
    },
    sort(obj1, obj2) {
      return +obj1.date.replace(/-/g, "") - +obj2.count.replace(/-/g, "");
    },
    tableLabel(val) {
      let label;
      let has = false;
      this.optionsAgg.forEach((item) => {
        if (item.value === val) {
          label = item.label;
          has = true;
        }
      });
      if (!has) {
        if (val === "date") {
          label = "日期";
        } else if (val === "count") {
          label = "数量";
        }
      }
      return label;
    },
    changeTab(val) {
      this.activeTab = val;
    },

    // 初始化日期
    formatData(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },

    getList() {
      // this.loading = true;
    },

    search() {
      this.tableData = [];
      this.hList = [];

      if (!this.timeWrap) {
        this.$message({
          message: "请选择时间",
          type: "warning",
        });
        return false;
      }

      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.temp));
      params.s_dt = this.timeWrap[0];
      params.e_dt = this.timeWrap[1];
      newList(params)
        .then((res) => {
          this.tableData = res.data;
          this.pagination.total = res.data.length;
          let filList = {};
          let _newList = {};

          this.tableData.forEach((item) => {
            for (let key in item) {
              if (this.hList.indexOf(key) === -1 && key !== "count") {
                this.hList.push(key);
                if (key !== "date") {
                  filList[key] = [];
                  _newList[key] = [];
                }
              }
            }
          });

          this.tableData.forEach((item) => {
            for (let _key in filList) {
              if (filList[_key].indexOf(item[_key]) === -1) {
                filList[_key].push(item[_key]);
              }
            }
          });

          for (let _ind in filList) {
            filList[_ind].forEach((item) => {
              _newList[_ind].push({
                text: item,
                value: item,
              });
            });
          }

          this.filterList = _newList;

          //  把count 放最后一行
          this.hList.push("count");
          this.copyHlist = JSON.parse(JSON.stringify(this.hList));

          let _cpList = [];
          this.copyHlist.forEach((item) => {
            _cpList.push({
              prop: item,
              asc: this.temp.orderby[item] === 1 ? true : false,
              des: this.temp.orderby[item] === -1 ? true : false,
            });
          });
          this.sortList = _cpList;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset() {
      this.tableData = [];
      this.hList = [];
      Object.assign(this.$data.temp, this.$options.data.call(this).temp);
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex($ali, $jus) {
  display: flex;
  align-items: $ali;
  justify-content: $jus;
}

.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.top-search {
  display: flex;
  padding: 20px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #f0f3f7;
}
.table-container {
  min-height: 400px;
  // margin-top: 20px;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eff2f7;
}
.search {
  width: 100%;
  background: #ffffff;
  // border-radius: 10px;
  overflow: hidden;
  .content {
    @include flex(flex-start, space-between);
    // flex-direction: column;
    border-radius: 4px;
    // height: 76px;
    width: 100%;
    margin: 0 auto;
  }
}
.pageContain {
  @include flex(center, flex-end);
  margin-top: 20px;
}
.search-btn {
  background-color: #2d3a5b;
  border: #2d3a5b;
}
.reset-btn {
  background-color: #ffffff;
  color: #2d3a5b;
  border: 1px solid #2d3a5b;
}

.tab-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  // margin-top: 20px;
  background-color: #fff;
  // border: 1px solid #2d3a5b;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  &-top {
    width: 100%;
    color: #fff;
    background-color: rgba(45, 58, 91, 0.9);
    border-bottom: 1px solid #e4e7ed;
  }
  &-bottom {
    width: 100%;
  }
}
.active {
  color: #2d3a5b;
  background-color: #fff;
}
.tab-title {
  @include flex(center, center);
  width: 120px;
  height: 50px;
  cursor: pointer;
}
.table-tip {
  margin: 30px;
  font-size: 18px;
  font-weight: 400;
}
.table-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  margin-top: 20px;

  color: #2d3a5b;
  background-color: #ffffff;
}
.right-btns {
  float: right;
  padding-right: 20px;
}
.el-form-item {
  margin-bottom: 0;
}
.el-form-item__label {
  padding: 0 !important;
}
.chart-container {
  padding: 20px;
}
.sortActive {
  color: red !important;
}
.sortDscActive {
  color: #00cc00 !important;
}
</style>
